import React from 'react';

import { LinkWithPulse } from '../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';

export type PaginationProps = {
  pageCount: number;
  pageId: string;
  currentPage: number;
  location: string;
};

const Pagination: React.FC<PaginationProps> = ({
  pageCount,
  currentPage,
  pageId,
  location,
}) => (
  <div className="tag-pagination">
    {[...Array(pageCount).keys()].map((i) => {
      const pageNumber = i + 1;
      const isActivePage =
        currentPage === pageNumber || (!currentPage && i === 0);

      return isActivePage ? (
        <span className="tag-page" key={`page-${pageNumber}`}>
          {pageNumber}
        </span>
      ) : (
        <LinkWithPulse
          className="tag-page"
          objectId={`page-${pageNumber}`}
          name="Pagination element"
          key={`page-${pageNumber}`}
          href={`/${location}/${pageId}${i > 0 ? `?page=${pageNumber}` : ''}`}
        >
          {pageNumber}
        </LinkWithPulse>
      );
    })}
  </div>
);

export default Pagination;
